// Kinds of files by their type (um/2026-10-30/03 п.8): the icon and the word of a file without a thumbnail, and which files have one.

export type FileKind = 'image' | 'pdf' | 'video' | 'audio' | 'archive' | 'text' | 'other';

export function kindOf(type: string, name = ''): FileKind {
  const t = type.split(';')[0]!.trim().toLowerCase();
  const ext = name.split('.').pop()!.toLowerCase();
  if (t.startsWith('image/') || ['png', 'jpg', 'jpeg', 'webp', 'gif', 'avif'].includes(ext)) return 'image';
  if (t === 'application/pdf' || ext === 'pdf') return 'pdf';
  if (t.startsWith('video/') || ['mp4', 'webm', 'mov'].includes(ext)) return 'video';
  if (t.startsWith('audio/') || ['mp3', 'wav', 'ogg', 'm4a'].includes(ext)) return 'audio';
  if (['zip', 'rar', '7z', 'gz'].includes(ext) || /zip|compressed/.test(t)) return 'archive';
  if (t.startsWith('text/') || ['txt', 'csv', 'md', 'doc', 'docx', 'odt', 'rtf'].includes(ext)) return 'text';
  return 'other';
}

export const KIND_ICON: Record<FileKind, string> = { image: 'fileImage', pdf: 'filePdf', video: 'fileVideo', audio: 'fileAudio', archive: 'fileArchive', text: 'file', other: 'file' };
export const KIND_LABEL: Record<FileKind, string> = { image: 'Изображение', pdf: 'PDF', video: 'Видео', audio: 'Аудио', archive: 'Архив', text: 'Документ', other: 'Файл' };

/** «12 КБ», «3.4 МБ»; an unknown size (a record's file in the list) — empty. */
export const fileSize = (n: number) => (!n ? '' : n >= 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} МБ` : n >= 1024 ? `${Math.round(n / 1024)} КБ` : `${n} Б`);
